import { paramateStyles } from "./styles.ts";
import styleText from './as-viewport-wrapper.css?raw';

export class AsViewportWrapper extends HTMLElement {
  private viewport: any;
  private configurator: any;
  private observer: MutationObserver;
  private static readonly sheet = (() => {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(styleText + paramateStyles);
    return sheet;
  })();

  static get observedAttributes() {
    return ['width', 'height'];
  }
  public get viewportElement(): HTMLElement {
    return this.shadowRoot!.querySelector('#viewPort') as HTMLElement;
  }
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.shadowRoot!.adoptedStyleSheets = [
      ...this.shadowRoot!.adoptedStyleSheets,
      AsViewportWrapper.sheet
    ];
    this.shadowRoot!.innerHTML = /*html*/`
    <!-- as-viewport-wrapper  SHADOW >>> -->
    <div class="viewport-wrapper">
      <div id="viewPort" class="viewPort"></div>
      <slot name="top-right"></slot>
      <slot name="top-left"></slot>
      <slot name="bottom-right"></slot>
      <slot name="bottom-left"></slot>
    </div>
    <!-- as-viewport-wrapper -->
    `;

    // Initialize MutationObserver
    this.observer = new MutationObserver(this.handleMutations.bind(this));

    // Listen for as-cfgr-comp-ready event
    document.addEventListener('as-cfgr-comp-ready', this.handleConfiguratorCreated.bind(this));

    // Request configurator if not available
    if (!this.configurator) {
      // this.requestConfigurator();
    }
  }

  connectedCallback() {
    // Start observing the component's child nodes
    this.observer.observe(this, { childList: true, subtree: true });

    // Apply initial width/height if set
    const width = this.getAttribute('width');
    const height = this.getAttribute('height');
    if (width || height) {
      this.updateViewportSize(width, height);
    }

    window.addEventListener('configurator-initialized', (event: CustomEvent) => {
      // console.log("VIEWPORT: Configurator initialized event received", event);
      
      this.viewport = event.detail.configurator.viewPort;
      setTimeout(() => {
        this.dispatchCameraUpdate();
      }, 100);

      const userOnAnimCallback = this.viewport.onModelAnimationFrame;
      this.viewport.onModelAnimationFrame = () => {
        // console.log("VIEWPORT: Model animation frame");
        userOnAnimCallback?.();
        this.dispatchCameraUpdate();
      }
      this.dispatchEvent(new CustomEvent('as-viewport-ready', {
        detail: { viewport: this.viewport },
        bubbles: true,
        composed: true
      }));

      window.dispatchEvent(new CustomEvent('as-viewport-class', {
        detail: {
          vpComponent:this,
          viewport:event.detail.configurator.viewPort
        }
      }));
    });

    // Listen for as-get-paramate-vp events and respond with viewport instance if available
    window.addEventListener('as-get-paramate-vp', this.handleGetParamateVp);
  }

  disconnectedCallback(): void {
    // Clean up the observer when the element is disconnected
    this.observer.disconnect();
    window.removeEventListener('as-get-paramate-vp', this.handleGetParamateVp);
  }

  /**
   * Handle as-get-paramate-vp event
   */
  private handleGetParamateVp = (event: CustomEvent): void => {
    if (this.viewport) {
      event.detail.resolve(this.viewport);
    }
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
    if (oldValue === newValue) return;

    if (name === 'width' || name === 'height') {
      this.updateViewportSize(
        name === 'width' ? newValue : this.getAttribute('width'),
        name === 'height' ? newValue : this.getAttribute('height')
      );
    }
  }

  /**
   * Update viewport size
   */
  private updateViewportSize(width?: string | null, height?: string | null): void {
    const viewportDiv = this.shadowRoot?.querySelector('.viewPort') as HTMLElement;
    if (!viewportDiv) return;

    if (width) {
      viewportDiv.style.width = `${width}px`;
    }
    if (height) {
      viewportDiv.style.height = `${height}px`;
    }
  }

  /**
   * Handle configurator created event
   */
  private handleConfiguratorCreated(event: CustomEvent<{ configurator?: any }>): void {
    // console.log("Configurator created event received");
    this.configurator = event.detail?.configurator;

    if (!this.configurator) {
      console.warn('No configurator found in as-cfgr-comp-ready event');
      return;
    }
  }

  // setViewport(viewport: any) {
    
  // }


  // /**
  //  * Request configurator from tr-app ancestor
  //  */
  // private requestConfigurator(): void {
  //   this.dispatchEvent(new CustomEvent('get-configurator', {
  //     bubbles: true,
  //     composed: true,
  //     detail: {
  //       callback: (configurator: any) => {
  //         if (configurator) {
  //           // this.initializeViewport(configurator);
  //         }
  //       }
  //     },
  //   }));
  // }

  /**
   * Handle mutations in the DOM
   */
  private handleMutations(mutations: MutationRecord[]) {
    mutations.forEach(mutation => {
      if (mutation.type === 'childList') {
        // Check for any element being added as a direct child
        mutation.addedNodes.forEach(node => {
          if (node instanceof HTMLElement && !node.hasAttribute('slot')) {
            node.setAttribute('slot', 'top-right');
          }
        });
      }
    });
  }

  /**
   * Dispatches camera update event to all children
   */
  private dispatchCameraUpdate(): void {
    const cam = this.viewport?.getCameraParams?.();
    if (cam) {
      // Dispatch to specific axis display component
      const axisDisplay = this.querySelector('as-axis-display');
      if (axisDisplay) {
        axisDisplay.dispatchEvent(new CustomEvent('as-viewport-camera-update', {
          detail: { cam }
        }));
      }

      // Also dispatch bubbling event for any other interested components
      window.dispatchEvent(new CustomEvent('as-viewport-camera-update', {
        detail: { cam },
        bubbles: true,
        composed: true
      }));
    }
  }
}

// Check if the element is already defined before registering it
if (!customElements.get('as-viewport-wrapper')) {
  customElements.define('as-viewport-wrapper', AsViewportWrapper);
} else {
  console.warn("as-viewport-wrapper already defined");
}


